/* eslint-disable no-alert */
import {Layout} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {postCreateFreePayment} from '../../apis';
import {DRAWER_ROUTES} from '../../navigation/constants';
import {getSubjectNameById, px, useAsyncFn, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {LoadingButton} from '../components';
import ConfirmPurchaseModal from './ConfirmPurchaseModal';
import {PaymentErrorModal} from './PaymentErrorModal';

const FreeMonthPayment = ({
  navigation,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  monthNumber,
  isRenew,
  handleClosePaymentModal,
}) => {
  var isPaymentError = false;
  const isLandscape = useIsLandscape();
  const subjects = useSelector((state) => state.general.subjects);

  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  if (!isRenew) {
    if (
      selectedTimeTable &&
      selectedTimeTable.length > 0 &&
      selectedTimeTable[0].scheduleId
    ) {
      //console.log('Process to payment');
    } else {
      isPaymentError = true;
    }
  }

  useEffect(() => {
    if (!isPaymentError) {
      handlePurchase();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentError]);

  const [{loading}, handlePurchase] = useAsyncFn(
    async (receipt) => {
      if (!selectedTimeTable?.[0]?.scheduleId) {
        alert('Your payment session is expired, please try again!');
        if (isLandscape) {
          handleClosePaymentModal();
        }
        navigation.navigate(DRAWER_ROUTES.home.path);
        return;
      }

      try {
        const subjectNamesData = subjectNames
          ? subjectNames.replace(/ /g, '')
          : selectedTimeTable
              ?.map(({subjectId}) =>
                getSubjectNameById({id: subjectId, subjects}),
              )
              .join(',');

        const response = await postCreateFreePayment({
          kidId,
          receipt,
          packageId,
          selectedTimeTable,
          subjectNames: subjectNamesData,
          renewData,
          monthNumber,
        });
        const {status, message} = response || {};

        setSuccessMessage({
          title: status ? 'Done' : 'Error!',
          text: message || 'Something went wrong!',
        });
        setIsPaymentSuccess(true);
      } catch (error) {
        alert(String(error));
        navigation.navigate(DRAWER_ROUTES.home.path);
      }
    },
    [kidId, packageId, selectedTimeTable, subjectNames, renewData],
  );

  const onModalClose = () => {
    setIsPaymentSuccess(false);
    if (isLandscape) {
      handleClosePaymentModal();
    }
    navigation.navigate(DRAWER_ROUTES.home.path);
  };

  return (
    <Layout>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      <LoadingButton
        loading={loading}
        style={styles.button}
        onPress={handlePurchase}>
        {'Confirm'}
      </LoadingButton>

      {isPaymentSuccess && (
        <ConfirmPurchaseModal
          title={successMessage?.title || 'Oops'}
          text={successMessage?.text || 'Something went wrong'}
          onClose={() => onModalClose()}
          visible={true}
        />
      )}
    </Layout>
  );
};

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  rowInput: {
    width: '50%',
  },
  button: {
    marginTop: 60,
    marginHorizontal: px(57),
  },
});

export default FreeMonthPayment;
